import request from 'axios';

export const SEND_CONTACT = 'crowdspring/help/SEND_CONTACT';
export const SEND_CONTACT_REQUEST = 'crowdspring/help/SEND_CONTACT_REQUEST';
export const SEND_CONTACT_FAILURE = 'crowdspring/help/SEND_CONTACT_FAILURE';
export const SEND_CONTACT_SUCCESS = 'crowdspring/help/SEND_CONTACT_SUCCESS';

export function sendContact(data) {
  const opts = {
    method: 'post',
    url: '/api/v1/contact/',
    data,
  };

  return dispatch => {
    dispatch({ type: SEND_CONTACT_REQUEST });

    request(opts).then(() => (
      dispatch({ type: SEND_CONTACT_SUCCESS })
    )).catch(() => (
      dispatch({ type: SEND_CONTACT_FAILURE })
    ))
  };
}

export function sendAgencyContact(data) {
  const opts = {
    method: 'post',
    url: '/api/v1/contact-agencies/',
    data,
  };

  return dispatch => {
    dispatch({ type: SEND_CONTACT_REQUEST });

    request(opts).then(() => (
      dispatch({ type: SEND_CONTACT_SUCCESS })
    )).catch(() => (
      dispatch({ type: SEND_CONTACT_FAILURE })
    ))
  };
}

export const INITIAL_STATE = {
  isLoading: false,
  error: null,
  failure: false,
  success: false,
};


export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SEND_CONTACT_REQUEST:
      return {
        ...state,
        data: null,
        isLoading: true,
      };
    case SEND_CONTACT_SUCCESS:
      return {
        ...state,
        success: true,
        failure: false,
        isLoading: false,
      };
    case SEND_CONTACT_FAILURE:
      return {
        ...state,
        error: action.payload,
        failure: true,
        isLoading: false,
        success: false,
      };
    default:
      return state;
  }
}
